import type { MarketExceptionType } from '../../MarketExceptionTypes'

export const CA: MarketExceptionType = {
  hasStoreCredit: true,
  marketoSmsOptIn: false,
  signUpReCaptcha: true,
  showPasswordRequirements: true,
  signupPrivacyPolicy: {
    enabled: true,
    required: true,
  },
  checkoutTermsAndConditionsAgreementCheckbox: {
    enabled: true,
    required: true,
  },
  checkoutTermsAndConditionsStatement: false,
  disableAccountPaymentMethods: false,
  currencyCode: 'CAD',
  creditCardProvidersSupported: ['MC', 'VI', 'AX', 'DI'],
  isWorldPay3DS: false,
  poboxRestricted: false,
  isPickupMarket: true,
  hasAddressRegion: true,
  allowShippingToExternalCountries: false,
  supportsStoreCredit: true,
  applePayOTP: true,
  applePaySubscriptions: false,
  hasPaypal: true,
  hasAddressValidation: true,
  hasPaypal3DS: false,
  hasShipByDate: false,
  allowSubscriptionPickup: false,
  hasProductAvailability: true,
  skuAvailabilityShippingMethod: 'Canada Post',
  defaultEconomyShippingMethod: 'Canada Post',
  hasZipCode: true,
  restrictedPickupLocations: [
    {
      location: 'Toronto Pickup Center',
      regions: ['ON', 'Ontario'],
      coordinates: {
        latitude: 43.696_312_406_285_47,
        longitude: -79.616_193_342_806,
      },
      miles: 75,
    },
  ],
  skuPricingOverrides: [
    '35979',
    '36103',
    '36145',
    '36144',
    '36152',
    '36151',
    '36332',
    '36333',
    '36330',
    '36331',
    '36336',
    '36337',
    '36334',
    '36335',
  ],
}
